import { render } from "./FormDropZone.vue?vue&type=template&id=21812a98"
import script from "./FormDropZone.vue?vue&type=script&lang=js"
export * from "./FormDropZone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__